<h1 class="title">Provlista i detalj</h1>
<p class="brodtext-medium-14">
  I provlistan visas information om respektive fynd. Om AST resultat finns går dessa att se genom att fälla ut <br>
  informationen under fyndet.
</p>

<h2>Sökresultat - Sammanställning</h2>

<app-search-params></app-search-params>

<h5>Resultat</h5>
<div class="result-grid">
  <div>
    <div>Antal prov</div>
    <div>{{ formatBigNumber(totalRecords) }}</div>
    <div *ngIf="countLoading"><i class="fa fa-spinner fa-spin"></i></div>
  </div>
  <div>
    <div>Antal KML</div>
    <div>{{ numberOfKML }}</div>
    <div *ngIf="kmlLoading"><i class="fa fa-spinner fa-spin"></i></div>
  </div>
</div>
<p class="link-like mt-4" (click)="getRowDataCsv()">
  <i class="fa fa-download"></i> Ladda ner provlista i CSV-fil
</p>
@if (globalStateService.csvDownloadInProgress | async) {
  <div class="downloading">
    <p class="download-in-progress"><i class="fa-solid fa-spinner fa-spin"></i> Pågående nedladdning av CSV-fil</p>
    <p>
      Du kan följa nedladdningen i toppen av högra hörnet på hemsidan. Du kan röra dig fritt i Svebar under
      nedladdningen, undvik dock att genomföra en ny sökning medan nedladdning pågår.
    </p>
  </div>
}
<div class="mb-4">
  <app-table [config]="tableConfig" [lazy]="true" (sortEvent)="sort($event)" [totalRecordsLazy]="totalRecords" [loading]="loading">
    <div detailsView>
      @if (currentRow) {
        @if (this.searchParams.searchType === searchTypes.NAMNARDATA) {
          <h4 class="fynd">Fynd</h4>
          <div class="fynd-grid">
            <ng-container *ngFor="let fynd of currentRow.fynd; let index = index">
              {{ fynd.smittamne }} <span class="mx-4 divider" *ngIf="index !== currentRow.fynd.length - 1">|</span>
            </ng-container>
          </div>
        } @else {
          <div class="fynd" *ngFor="let fynd of currentRow.fynd">
            <h3 class="smittamne">
              {{ fynd.smittamne }}
            </h3>

            <div class="antibiotika-result">
              <div class="grid header">
                <span>Antibiotika</span>
                <span>Diskstyrka</span>
                <span>SIR</span>
                <span>Zon</span>
                <span>Tolkning MIC</span>
                <span>MIC</span>
              </div>

              <div class="grid" *ngFor="let antibiotika of fynd.antimicroList">
                <span>{{ antibiotika.antibiotikum_namn }}</span>
                <span>{{ antibiotika.diskStyrka !== "" ? antibiotika.diskStyrka : "-" }}</span>
                <span>{{ antibiotika.sir !== "" ? antibiotika.sir : "-" }}</span>
                <span>{{ antibiotika.zon ?? "-" }}</span>
                <span>{{ antibiotika.tolk !== "" ? antibiotika.tolk : "-" }}</span>
                <span>{{ antibiotika.mic ?? "-" }}</span>
              </div>
            </div>
          </div>
        }
      }
    </div>
  </app-table>
</div>
